const ROOT_URL = 'https://lci-mylion-app-dev.azurewebsites.net';
export const environment = {
  production: true,
  auth_authority: 'https://lci-auth-app-dev.azurewebsites.net/',
  apiUrl: 'https://lci-user-api-dev.azurewebsites.net/api/',
  apiRootUrl: 'https://lci-user-api-dev.azurewebsites.net/',
  mobileApiUrl: 'https://lci-mylion-activities-api-dev.azurewebsites.net/',
  reportingApiUrl: 'https://lci-insights-api-dev.azurewebsites.net/',
  configApi: 'https://lci-config-api-dev.azurewebsites.net/',
  signalRUrl: 'https://lci-websockets-app-dev.azurewebsites.net',
  auth_redirect_uri: ROOT_URL + '/auth-callback',
  auth_silent_redirect_uri: ROOT_URL + '/silent-refresh.html',
  auth_client_id: 'js',
  auth_post_logout_redirect_uri: ROOT_URL + '/signout',
  app_switcher_url: 'https://lci-myapps-app-dev.azurewebsites.net',
  googleAnalyticsId: 'UA-93183220-3',
  googleApiKey: 'AIzaSyA1ZTBjpmbF_0hzS_w6IYK8mHhUvXO-Ccc',
  messageAppUrl: 'https://lci-mylion-messages-app-dev.azurewebsites.net',
  userProfileAppUrl: 'https://lci-mylion-userprofile-app-dev.azurewebsites.net',
  applicationInsightsInstrumentationKey: '304c7b90-7f13-4d1e-9f72-90a741348f48',
  clubActivityDetailTemplate:
    'https://lcimylionst001dev.blob.core.windows.net/reportstemplate/ClubActivityDetails.xlsx',
  districtActivityDetailTemplate:
    'https://lcimylionst001dev.blob.core.windows.net/reportstemplate/DistrictActivityDetails.xlsx',
  mdActivityDetailTemplate:
    'https://lcimylionst001dev.blob.core.windows.net/reportstemplate/MDActivityDetails.xlsx',
  summaryReportTemplate:
    'https://lcimylionst001dev.blob.core.windows.net/reportstemplate/SummaryReport.xlsx',
  clubActivityDetails: 'ClubActivityDetails',
  districtActivityDetails: 'DistrictActivityDetails',
  mdActivityDetails: 'MDActivityDetails',
  districtSummaryReport: 'DistrictSummaryReport',
  MDSummaryReport: 'MDSummaryReport',
  CASummaryReport: 'CASummaryReport',
  LCISummaryReport: 'LCISummaryReport',
  gtmTrackingID:"GTM-NSPW6XZ"
};
